import React from "react";
import "./styles.scss";

const Input = ({ name, type, onChange, value, placeholder, ...rest }) => {
  return (
    <input
      name={name}
      type={type}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      className="input"
      {...rest}
    />
  );
};

export default Input;
